"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistAuthState = persistAuthState;
exports.getPersistedAuthState = getPersistedAuthState;
var tsafe_1 = require("../vendor/frontend/tsafe");
function getKey(params) {
    var configId = params.configId;
    return "oidc-spa:auth-state:".concat(configId);
}
function persistAuthState(params) {
    var configId = params.configId, state = params.state;
    var key = getKey({ configId: configId });
    if (state === undefined) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, state);
}
function getPersistedAuthState(params) {
    var configId = params.configId;
    var value = localStorage.getItem(getKey({ configId: configId }));
    if (value === null) {
        return undefined;
    }
    (0, tsafe_1.assert)(value === "logged in" || value === "explicitly logged out");
    return value;
}
//# sourceMappingURL=persistedAuthState.js.map